import React, { FC } from "react";

interface Props {
  dayOfMonth: number;
  date?: Date | undefined;
  unavailableDates?: Date[];
  partiallyUnavailable?: boolean;
  partialTimes?: { from: string; to: string }[];
  home?: boolean;
}

const DatePickerCustomDay: FC<Props> = ({
  dayOfMonth,
  date,
  unavailableDates = [],
  partiallyUnavailable = false,
  home,
}) => {
  const isUnavailable = date
    ? unavailableDates.some(
        (unavailableDate) =>
          unavailableDate.toDateString() === date.toDateString(),
      )
    : false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const isPastDate = date ? date < today : false;

  return (
    <span
      className={`react-datepicker__day_span flex flex-col items-center ${
        isUnavailable ? "line-through" : ""
      }`}
    >
      <span>{dayOfMonth}</span>
      {!home && (
        <>
          <div
            className="w-8 h-1.5 rounded-full border-[0.5px] border-gray-300 shadow-sm"
            style={{
              background: isPastDate
                ? "#6B7280"
                : isUnavailable
                  ? "#B22222"
                  : partiallyUnavailable
                    ? "linear-gradient(to right, #B22222 50%, green 50%)"
                    : "green",
            }}
          />
        </>
      )}
    </span>
  );
};

export default DatePickerCustomDay;
